import { RenderElementProps } from 'slate-react';

import SafeLink from '../../common/TextArea/SafeLink.jsx';
import { CustomElement } from './constants.js';
import { getClassesByTextStyle } from './utils.jsx';

export const renderEditorElement = ({
  attributes,
  children,
  element,
}: RenderElementProps) => {
  const customElement = element as CustomElement;

  const styledChildren = (
    <span className={getClassesByTextStyle(customElement.type)}>
      {children}
    </span>
  );

  switch (customElement.type) {
    case 'block-quote':
      return <blockquote {...attributes}>{styledChildren}</blockquote>;
    case 'bulleted-list':
      return children.length ? (
        <ul {...attributes} className="ml-4 min-h-16! list-disc">
          {styledChildren}
        </ul>
      ) : null;
    case 'numbered-list':
      return children.length ? (
        <ol {...attributes} className="ml-4 min-h-16! list-decimal">
          {styledChildren}
        </ol>
      ) : null;
    case 'heading-one':
      return <h1 {...attributes}>{children}</h1>;
    case 'heading-two':
      return <h2 {...attributes}>{children}</h2>;
    case 'heading-three':
      return <h3 {...attributes}>{children}</h3>;
    case 'heading-four':
      return <h4 {...attributes}>{children}</h4>;
    case 'heading-five':
      return <h5 {...attributes}>{children}</h5>;
    case 'heading-six':
      return <h6 {...attributes}>{children}</h6>;
    case 'list-item':
      return children.length ? <li {...attributes}>{styledChildren}</li> : null;
    case 'link':
      return (
        <SafeLink href={customElement.url ?? ''} attributes={attributes}>
          {styledChildren}
        </SafeLink>
      );
    default:
      return (
        <p {...attributes} className="min-h-16!">
          {styledChildren}
        </p>
      );
  }
};
